<template>
  <div class="tabClass">
    <el-card>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :key="1" :label="$t('uploadFile.expressTimeliness')" name="timeToCustomer">
          <timeToCustomer />
        </el-tab-pane>
        <el-tab-pane :key="0" :label="$t('uploadFile.internalLeadTime')" name="internalTime">
          <internalTime />
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>
<script>
export default {
  name: 'CustomerTimelinessManagement',
  components: {
    timeToCustomer: () => import('./component/timeToCustomer.vue'),
    internalTime: () => import('./component/internalTime.vue')
  },
  data() {
    return {
      activeName: 'timeToCustomer',
      noRouteAssociated: 0
    };
  },
  methods: {
    handleClick(tab, event) {
      // if (tab.name === 'internalTime') {
      //   this.isShow1 = false;
      //   this.isShow = true;
      // }
      // if (tab.name === 'timeToCustomer') {
      //   this.isShow = false;
      //   this.isShow1 = true;
      // }
    }
  }
};
</script>

<style scoped>
.tabClass {
  padding: 0 10px;
}
</style>
